import LInput from "@components/LInput";
import type { SolanaEmailModalProps } from "@components/modals/SolanaEmailModal/types";
import {
  BottomSheetPlainLayout,
  BottomSheetSubmitButton,
  BottomSheetSubtitle,
  BottomSheetTitle,
} from "@utils/swmModal/components/BottomSheetPrimitives";
import AppModalSheet from "@utils/appModal/components/AppModalSheet";
import { theme } from "@theme";
import { forwardRef, useState } from "react";
import { type SheetAdapterRef } from "react-native-bottom-sheet-stack";

type SolanaEmailModalSWMContentProps = SolanaEmailModalProps & {
  closeModal: () => void;
};

const SolanaEmailModalSWM = ({
  closeModal,
  onEmailEntered,
}: SolanaEmailModalSWMContentProps) => {
  const [email, setEmail] = useState("");

  return (
    <BottomSheetPlainLayout contentProps={{ gap: "m1", pb: "s3" }}>
      <BottomSheetTitle textAlign="left">
        Add your email address
      </BottomSheetTitle>
      <BottomSheetSubtitle textAlign="left">
        Please enter your email address to continue.
      </BottomSheetSubtitle>
      <LInput
        autoCapitalize="none"
        keyboardType="email-address"
        onChangeText={setEmail}
        placeholder="Email"
        placeholderTextColor={theme.colors.blackTranslucent50}
        style={{
          backgroundColor: theme.colors.whiteTranslucent80,
          borderColor: theme.colors.blackTranslucent10,
          color: theme.colors.black,
        }}
        value={email}
        variant="primary"
      />
      <BottomSheetSubmitButton
        accessibilityLabel="Continue"
        enabled={!!email.length}
        label="Continue"
        onPress={async () => {
          await onEmailEntered(email);
          closeModal();
        }}
        sentryEventName="solana_email_modal_continue_button_swm"
        testID="solana-email-modal-continue-swm"
      />
    </BottomSheetPlainLayout>
  );
};

export const SolanaEmailModalSWMSheet = forwardRef<
  SheetAdapterRef,
  SolanaEmailModalProps
>(function SolanaEmailModalSWMSheet({ onEmailEntered }, ref) {
  return (
    <AppModalSheet ref={ref} keyboardBehavior="inset">
      {({ closeModal }) => (
        <SolanaEmailModalSWM
          closeModal={closeModal}
          onEmailEntered={onEmailEntered}
        />
      )}
    </AppModalSheet>
  );
});

export default SolanaEmailModalSWM;
